import React, { useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { useDispatch } from "react-redux";
import { resendTrialCredentials } from "../redux/reducers/trialSlice";
import logo from "../assets/logo.png";
import { FiMail, FiArrowRight, FiRefreshCw } from "react-icons/fi";

const TrialSuccess = () => {
  const [searchParams] = useSearchParams();
  const email = searchParams.get("email") || "";
  const dispatch = useDispatch();
  const [resending, setResending] = useState(false);
  const [resendMsg, setResendMsg] = useState("");
  const [resendError, setResendError] = useState("");

  const handleResend = async () => {
    if (!email) return;
    setResending(true);
    setResendMsg("");
    setResendError("");
    try {
      const result = await dispatch(resendTrialCredentials(email)).unwrap();
      setResendMsg(result);
    } catch (err) {
      setResendError(err);
    } finally {
      setResending(false);
    }
  };

  return (
    <div className="min-h-screen bg-gray-50 flex flex-col">
      <header className="bg-[#3d184e] h-16 flex items-center px-6">
        <Link to="/" className="flex items-center gap-2">
          <img src={logo} alt="Logo" className="h-7 w-auto" />
          <span className="text-white font-bold hidden sm:block">
            Revenue Pro Planner<span className="text-[#C9A84C]">™</span>
          </span>
        </Link>
      </header>

      <div className="flex-1 flex items-center justify-center px-4 py-16">
        <div className="bg-white rounded-2xl border border-gray-200 shadow-sm p-10 max-w-md w-full text-center">
          <div className="w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-6" style={{ background: "#e4f6f8" }}>
            <FiMail className="text-2xl" style={{ color: "#2e97a9" }} />
          </div>
          <h1 className="text-2xl font-bold text-[#2a496e] mb-3">Check Your Inbox!</h1>
          <p className="text-gray-500 text-sm leading-relaxed mb-2">
            Your free trial account has been created. We've sent your login credentials to
          </p>
          {email && (
            <p className="text-[#2e97a9] font-semibold text-sm mb-4">{email}</p>
          )}
          <p className="text-gray-400 text-xs mb-6">Check your inbox and spam folder to get started.</p>

          <div className="bg-[#f3fafb] rounded-xl p-4 mb-6 text-left text-sm space-y-2">
            <p className="text-gray-600"><span className="font-medium">✅ Account created</span> — Trial active for 7 days</p>
            <p className="text-gray-600"><span className="font-medium">📧 Email sent</span> — Login credentials in your inbox</p>
            <p className="text-gray-600"><span className="font-medium">🚀 Full access</span> — All features unlocked</p>
          </div>

          <Link
            to="/login"
            className="w-full flex items-center justify-center gap-2 font-bold py-3 rounded-xl text-sm transition-all hover:brightness-110 mb-4"
            style={{ background: "#C9A84C", color: "#3d184e" }}
          >
            Go to Login <FiArrowRight />
          </Link>

          {/* Resend section */}
          {email && (
            <div className="border-t border-gray-100 pt-4">
              {resendMsg ? (
                <p className="text-[#2e97a9] text-xs font-medium">{resendMsg}</p>
              ) : resendError ? (
                <p className="text-red-500 text-xs">{resendError}</p>
              ) : (
                <p className="text-gray-400 text-xs mb-2">Didn't receive the email?</p>
              )}
              {!resendMsg && (
                <button
                  onClick={handleResend}
                  disabled={resending}
                  className="flex items-center justify-center gap-1.5 mx-auto text-xs font-medium text-[#2e97a9] hover:text-[#2a496e] disabled:opacity-50 transition-colors"
                >
                  <FiRefreshCw className={resending ? "animate-spin" : ""} />
                  {resending ? "Sending..." : "Resend login credentials"}
                </button>
              )}
            </div>
          )}

          <p className="text-gray-400 text-xs mt-4">
            Need help? Email us at{" "}
            <a href="mailto:Support@revenueproplanner.com" className="hover:underline" style={{ color: "#2e97a9" }}>
              Support@revenueproplanner.com
            </a>
          </p>
        </div>
      </div>
    </div>
  );
};

export default TrialSuccess;
